// extracted by mini-css-extract-plugin
export default {"mainContentWrapper":"AbPKFk","hidden":"djHlZv","actions":"NzWX4A"};